import { render, staticRenderFns } from "./Personalization.vue?vue&type=template&id=e283f118&scoped=true"
import script from "./Personalization.vue?vue&type=script&lang=ts"
export * from "./Personalization.vue?vue&type=script&lang=ts"
import style0 from "./Personalization.vue?vue&type=style&index=0&id=e283f118&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e283f118",
  null
  
)

export default component.exports